import React from 'react';
import Topnavigation from './Topnavigation';
import Footer from './Footer';
import SEO from './SEO';

const stats = [
  { count: '12+', label: 'Years Experience' },
  { count: '300+', label: 'Students Enrolled' },
  { count: '12+', label: 'Expert Staff' },
  { count: '500+', label: 'Study Notes' },
];

const values = [
  {
    icon: '🎯',
    title: 'Personalized Learning',
    desc: 'We tailor our teaching methods to each student\'s unique learning style, ensuring every student gets the attention they need to succeed.',
  },
  {
    icon: '👨‍🏫',
    title: 'Experienced Faculty',
    desc: 'Our educators bring years of teaching experience and passion to the classroom, nurturing students\' intellectual curiosity.',
  },
  {
    icon: '📚',
    title: 'Comprehensive Curriculum',
    desc: 'From foundational concepts to advanced topics, our curriculum covers everything students need to excel in exams.',
  },
  {
    icon: '🎮',
    title: 'Interactive Learning',
    desc: 'We incorporate multimedia resources, activities, and real-world examples to keep students engaged and motivated.',
  },
  {
    icon: '🌱',
    title: 'Holistic Development',
    desc: 'Beyond academics, we build critical thinking, communication, and problem-solving skills for lifelong success.',
  },
  {
    icon: '🏆',
    title: 'Proven Results',
    desc: 'Our students consistently achieve top results in board exams, a testament to our quality teaching and dedication.',
  },
];

const About_us = () => {
  return (
    <>
      <Topnavigation />
      <SEO
        title="About Us - Study-Link Coaching Classes"
        description="Study-Link Coaching Classes at 72, Ahilya Nagar, Scheme No. 51, 100 Feet Road, Sangam Nagar, Indore - 452006. Founded by Bharat Ghate in 2014. CBSE/ICSE, SSC, Commerce, Science & entrance exam coaching."
        keywords="about study link coaching indore, Bharat Ghate coaching indore, coaching classes sangam nagar indore, ahilya nagar coaching indore"
        url="/about-us"
      />

      {/* Hero Banner */}
      <div style={{ position: 'relative' }}>
        <img
          src="/assets/img/pens.jpg"
          alt="About Us"
          style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'cover' }}
        />
        <div style={{
          position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}>
          <h1 style={{ color: '#fff', fontWeight: 700, fontSize: 'clamp(26px, 5vw, 48px)', textAlign: 'center' }}>
            About Us
          </h1>
          <p style={{ color: '#ddd', fontSize: 'clamp(14px, 2vw, 18px)', textAlign: 'center', padding: '0 15px' }}>
            Empowering students since 2012
          </p>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: 'transparent', justifyContent: 'center', marginBottom: 0 }}>
              <li className="breadcrumb-item"><a href="/" style={{ color: '#009999' }}>Home</a></li>
              <li className="breadcrumb-item active" style={{ color: '#fff' }}>About Us</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Who We Are */}
      <section style={{ padding: '60px 0', background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center" style={{ gap: '30px 0' }}>
            <div className="col-12 col-lg-6">
              <img
                src="/assets/img/pens01.jpg"
                alt="Study Link Classes"
                style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'cover', borderRadius: 12, boxShadow: '0 8px 30px rgba(0,0,0,0.12)' }}
              />
            </div>
            <div className="col-12 col-lg-6" style={{ paddingLeft: '30px' }}>
              <span style={{ color: '#009999', fontWeight: 700, fontSize: 14, textTransform: 'uppercase', letterSpacing: 2 }}>
                Who We Are
              </span>
              <h2 style={{ fontWeight: 700, color: '#333', margin: '10px 0 16px', fontSize: 'clamp(22px, 3vw, 34px)' }}>
                Welcome to Study-Link Coaching Classes!
              </h2>
              <div style={{ width: 60, height: 3, background: '#009999', marginBottom: 20 }}></div>
              <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15, marginBottom: 16 }}>
                Founded in <strong>2014</strong> by <strong>Bharat Ghate</strong>, Study-Link Coaching Classes is located at
                <strong> 72, Ahilya Nagar, Scheme No. 51, 100 Feet Road, Sangam Nagar, Indore - 452006</strong>.
              </p>
              <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15, marginBottom: 24 }}>
                We provide CBSE/ICSE school tutoring, SSC, Commerce, Science, B.Com, B.Sc and entrance exam
                coaching for engineering and BCA. Our commitment to quality education and personal attention
                has made us one of the most trusted coaching centers in Indore.
              </p>
              <div className="row" style={{ gap: '12px 0' }}>
                {['SSC Coaching', 'Commerce Classes', 'Science Batches', 'Study Material', 'Regular Tests', 'Personal Attention'].map((item, i) => (
                  <div key={i} className="col-6">
                    <span style={{ color: '#009999', fontWeight: 700, marginRight: 8 }}>✔</span>
                    <span style={{ color: '#444', fontSize: 14 }}>{item}</span>
                  </div>
                ))}
              </div>
              <a href="/contact-us" style={{
                display: 'inline-block', marginTop: 28,
                background: '#009999', color: '#fff',
                padding: '12px 32px', borderRadius: 6,
                fontWeight: 600, fontSize: 15, textDecoration: 'none',
              }}>
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section style={{ background: '#009999', padding: '50px 0' }}>
        <div className="container">
          <div className="row text-center">
            {stats.map((s, i) => (
              <div key={i} className="col-6 col-md-3 mb-4 mb-md-0">
                <div style={{ borderRight: i < 3 ? '1px solid rgba(255,255,255,0.3)' : 'none', padding: '10px 0' }}>
                  <h2 style={{ color: '#fff', fontWeight: 800, fontSize: 'clamp(28px, 4vw, 42px)', marginBottom: 6 }}>
                    {s.count}
                  </h2>
                  <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 15, marginBottom: 0 }}>{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section style={{ padding: '60px 0', background: '#f9f9f9' }}>
        <div className="container">
          <div className="text-center mb-5">
            <span style={{ color: '#009999', fontWeight: 700, fontSize: 14, textTransform: 'uppercase', letterSpacing: 2 }}>
              What Drives Us
            </span>
            <h2 style={{ fontWeight: 700, color: '#333', marginTop: 8, fontSize: 'clamp(22px, 3vw, 34px)' }}>
              Our Core Values
            </h2>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '12px auto 0' }}></div>
          </div>
          <div className="row">
            {values.map((v, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4 mb-4">
                <div style={{
                  background: '#fff', borderRadius: 10, padding: '28px 24px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.07)', height: '100%',
                  borderTop: '3px solid #009999', transition: 'transform 0.3s, box-shadow 0.3s',
                }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 10px 28px rgba(0,153,153,0.18)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.07)';
                  }}
                >
                  <div style={{ fontSize: 36, marginBottom: 14 }}>{v.icon}</div>
                  <h5 style={{ fontWeight: 700, color: '#333', marginBottom: 10 }}>{v.title}</h5>
                  <p style={{ color: '#666', fontSize: 14, lineHeight: 1.8, marginBottom: 0 }}>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section style={{ padding: '60px 0', background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center" style={{ gap: '30px 0' }}>
            <div className="col-12 col-lg-6 order-lg-2">
              <img
                src="/assets/img/s-right.jpg"
                alt="Founder"
                style={{ width: '100%', height: 'auto', maxHeight: 400, objectFit: 'cover', borderRadius: 12, boxShadow: '0 8px 30px rgba(0,0,0,0.12)' }}
              />
            </div>
            <div className="col-12 col-lg-6 order-lg-1">
              <span style={{ color: '#009999', fontWeight: 700, fontSize: 14, textTransform: 'uppercase', letterSpacing: 2 }}>
                Our Story
              </span>
              <h2 style={{ fontWeight: 700, color: '#333', margin: '10px 0 16px', fontSize: 'clamp(22px, 3vw, 34px)' }}>
                From 12 Students to Hundreds
              </h2>
              <div style={{ width: 60, height: 3, background: '#009999', marginBottom: 20 }}></div>
              <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15, marginBottom: 16 }}>
                <strong>Bharat Ghate</strong>, the founder and principal of Study-Link Coaching Classes, started this
                journey in <strong>2014</strong> at <strong>72, Ahilya Nagar, Scheme No. 51, 100 Feet Road,
                Sangam Nagar, Indore - 452006</strong>.
              </p>
              <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15, marginBottom: 16 }}>
                We offer academic tutoring for primary classes, school curriculums (CBSE/ICSE), graduation
                courses like B.Com and B.Sc, and coaching for engineering/BCA entrances and competitive exams.
              </p>
              <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15 }}>
                Today, with a dedicated team of 12+ staff members, we continue to grow and serve our community
                with the same passion and dedication from our branch in Sangam Nagar, Indore.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: '#009999', padding: '50px 0' }}>
        <div className="container text-center">
          <h3 style={{ color: '#fff', fontWeight: 700, marginBottom: 12, fontSize: 'clamp(20px, 3vw, 30px)' }}>
            Join the Study-Link Family
          </h3>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: 25, fontSize: 16, maxWidth: 500, margin: '0 auto 25px' }}>
            Give your child the best start in education. Admissions are open now!
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/contact-us" style={{
              background: '#fff', color: '#009999',
              padding: '12px 32px', borderRadius: 6,
              fontWeight: 700, fontSize: 15, textDecoration: 'none',
            }}>
              Enquire Now
            </a>
            <a href="/courses" style={{
              background: 'transparent', color: '#fff',
              padding: '12px 32px', borderRadius: 6,
              fontWeight: 700, fontSize: 15, textDecoration: 'none',
              border: '2px solid #fff',
            }}>
              View Courses
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About_us;
